import React, { useEffect } from "react";
import "../styles/About.css";
import profile from "../assets/profile.jpeg";

/**
 * The About page provides information about the astrologer. It uses a
 * cursive font for the main heading to emulate handwritten text (pisano
 * pisavo in Slovenian). This adds a personal touch and differentiates
 * the page from others on the site.
 */
const About = () => {
  useEffect(() => {
    document.title = "O meni — Astrologija v Vortexu";
    const meta = document.querySelector('meta[name="description"]');
    if (meta)
      meta.setAttribute(
        "content",
        "O meni — certificirana astrologinja. Ponujam natalne karte, sinastrije in svetovanje."
      );
  }, []);

  return (
    <div className="about-page">
      <div className="about-bg" aria-hidden="true">
        <img className="about-bg-slide" src={profile} alt="" />
      </div>
      <div className="about-hero" />
      <div className="about-inner">
        <h2 className="about-title">O meni</h2>
        <div className="about-grid">
          <div className="about-text card fade-in">
            <p>
              Moje ime je Aleksandra in sem astrolog z visoko strokovnim znanjem
              astrologije. Z astrologijo se ukvarjam že vrsto let. Učila sem se
              jo v Sloveniji in kasneje tudi v tujini po principu Keplerjevega
              inštituta. Ker obožujem astrologijo in jo izvajam z vsem srcem, se
              vsaki stranki posvetim maksimalno.
            </p>
            <p>
              Res je, da sem precej načelen astrolog in ne rada govorim o
              "zvezdicah" in "rožicah", če tega v karti ne vidim, ampak se
              fokusiram predvsem na to, da svoji stranki pomagam pri izzivih in
              jo usmerim na pravo pot. Vsaka stranka s pomočjo moje
              interpretacije dobi jasne odgovore in usmeritve.
            </p>
            <p>
              Velik dokaz so moje redne stranke, ki se vedno znova vračajo in mi
              zaupajo.
            </p>
            <div className="about-stats">
              <div className="stat-item">
                <span className="stat-number">10+</span>
                <span className="stat-label">let izkušenj</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">500+</span>
                <span className="stat-label">analiziranih kart</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">95%</span>
                <span className="stat-label">zadovoljnih strank</span>
              </div>
            </div>
          </div>
          <aside className="about-side">
            <img src={profile} alt="Astrolog" className="about-photo card" />
            <div className="about-cta">
              <a className="button primary" href="/booking">
                Rezerviraj termin
              </a>
              <a
                className="button ghost"
                href="tel:+386040942579"
                aria-label="Pokličite nas na 040 942 579"
              >
                Pokličite nas
              </a>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default About;
